module.exports = __webpack_public_path__ + "media/images/top/seminars/logo-2726e1646d686aff75e426f98e3f6c76.png";